/*
 * @Author: mayanxia 
 * @Date: 2021-01-18 20:15:05 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-02 16:13:28
 */
/*  快捷菜单 */
<template>
    <div style="color: #00FAFE">
        <a-dropdown>
            <span class="action action-full ant-dropdown-link user-dropdown-menu" >
                <span>{{ $t('快捷键') }}</span>
                <a-icon type="down" />
            </span>
            <a-menu slot="overlay" class="user-dropdown-menu-wrapper" @click="onMenuClick">
                <a-menu-item key="lang-title" disabled>
                    <a-icon type="global" :style="{color: '#6287a8'}"/>
                    <span :style="{color: '#6287a8', fontSize: '12px'}">{{ $t('语言') }}</span>
                </a-menu-item>
                <a-menu-item v-for="lang in supportLangs" :key="lang.value">
                    <a>
                        <a-icon :type="lang.value === current ? 'check' : 'global'"/>
                        <span :style="lang.value === current ? {color: '#00FAFE', fontWeight: 'bold'} : null">{{ lang.label }}</span>
                    </a>
                </a-menu-item>
                <a-menu-item key="3">
                    <a @click="refresh">
                        <a-icon type="setting"/>
                        <span>{{ $t('刷新') }}</span>
                    </a>
                </a-menu-item>
                <a-menu-item key="0">
                    <router-link to="/sysHome">
                        <a-icon type="user"/>
                        <span>{{ $t('系统首页') }}</span>
                    </router-link>
                </a-menu-item>
                <a-menu-item key="1">
                    <a @click="changeScreen">
                        <a-icon type="setting"/>
                        <span>{{screenTypeName}}</span>
                    </a>
                </a-menu-item>
                <a-menu-item key="2">
                    <a @click="handleLogout">
                        <a-icon type="setting"/>
                        <span>{{ $t('退出登录') }}</span>
                    </a>
                </a-menu-item>
            </a-menu>
        </a-dropdown>
    </div>
</template>
<script>
import { mapActions, mapGetters,mapState } from 'vuex'
import { screenFullMixin } from '@/mixins/screenFullMixin'
import { SUPPORT_LANGS } from '@/i18n'
export default {
    mixins: [screenFullMixin],
    data() {
        return{
            isFullScreen: false
        }
    },
    computed: {
        supportLangs: () => SUPPORT_LANGS,
        current() {
            return this.$store.state.app.language
        },
        // i18n：全屏文案使用 computed 以响应语言切换
        screenTypeName() {
            return this.isFullScreen ? this.$t('退出全屏') : this.$t('切换全屏')
        }
    },
    methods: {
        ...mapGetters(["nickname", "avatar","userInfo"]),
        ...mapActions(["Logout"]),
        onMenuClick({ key }) {
            if (SUPPORT_LANGS.some(l => l.value === key) && key !== this.current) {
                this.$store.commit('SET_LANGUAGE', key)
            }
        },
        handleLogout() {
        const that = this

        this.$confirm({
            title: this.$t('提示'),
            content: this.$t('真的要注销登录吗 ?'),
            onOk() {
                return that.Logout({}).then(() => {
                // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
                that.$router.push({ path: '/user/login' });
                // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
                //window.location.reload()
                }).catch(err => {
                that.$message.error({
                    title: that.$t('错误'),
                    description: err.message
                })
                })
            },
            onCancel() {
            },
            });
        },
        changeScreen() {
            this.isFullScreen = !this.isFullScreen
            this.screenFull();
        },
        refresh() {
            this.$emit('refresh')
        }
    }
}
</script>
<style scoped>
.ant-dropdown-menu{
    background: #00053A;
    color: #96CFFF;
}
.ant-dropdown-menu-item>a, .ant-dropdown-menu-submenu-title>a{
    color: rgba(110,217,242,0.8);
}
.ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover{
    background-color:rgba(110,217,242,0.8);
    color: #fff;
}
.ant-dropdown-menu-item:hover a, .ant-dropdown-menu-submenu-title:hover a{
    color:#fff;
}
</style>